import { Component, Input } from '@angular/core';
import { Painel } from '../../models/painel';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'app-painel-card',
  imports: [MatCardModule, MatChipsModule],
  templateUrl: './painel-card.component.html',
  styleUrl: './painel-card.component.scss',
})
export class PainelCardComponent {
  @Input() item!: Painel;
}
